import { render, staticRenderFns } from "./FinancesProjectSpecialisation.vue?vue&type=template&id=654bbc32"
import script from "./FinancesProjectSpecialisation.vue?vue&type=script&lang=js"
export * from "./FinancesProjectSpecialisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports